module.exports = __webpack_public_path__ + "resources/img/img_security_TLS_SSL_certificate1_en.b80267f7e5ab579eb3139b3a4c1a76cb.png";